import { WikiPage } from "../../WikiPage";
export class WikiPageScanEquivalenceClasses extends WikiPage {
    render() {
        this.todo();
    }
}
